/* global setGaqPush */
import '@PROJECT_ROOT/assets/desktop/js/apply/phoneSingle';
import fetchStateFromHtml from '@PROJECT_ROOT/assets/shared/js/fetchStateFromHtml';

const state = fetchStateFromHtml();

$(() => {
    const form = document.getElementById('sf_apply_apply_form');
    form.addEventListener('submit', () => {
        if (state.isProvider) {
            setGaqPush('Iznajmljivač', 'Registracija');
        }
    });
});
